import React, { useEffect, useState } from "react";
import SideNav from "../../Layout/SideNav";
import styled from "styled-components";
import { useParams, useHistory } from "react-router";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import APIModel from "../../../Models/APIModel";
import alertify from "alertifyjs";
import Loader from "react-loader-spinner";
import ViewEstimateTable from "./ViewEstimateTable";
import Grid from "@material-ui/core/Grid";
import {
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Divider,
} from "@material-ui/core";
import { displayAlertifyError } from "../../../util/functions";

const host = APIModel.HOST;
// const token = localStorage.getItem("Token");
const user_status = localStorage.getItem("status");

const ViewEstimate = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isMailLoading, setIsMailLoading] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const history = useHistory();
  const estimateParamId = useParams().id;
  const [token, setToken] = useState(localStorage.getItem("Token"));
  const [addressmain, setAddressmain] = useState('');

  useEffect(() => {
    setToken(localStorage.getItem("Token"));
  }, []);

  // states
  const [estimateData, setestimateData] = useState({});
  const [clientData, setClientData] = useState({});
  const [loading, setLoading] = useState(true);
  // effects
  useEffect(() => {
    getestimateData(estimateParamId);
  }, []);

  // functions

  const handleGenerateInvoice = () => {
    if (estimateData.client_id && clientData) {
      const param = {
        user_id: clientData.user_id,
        client_id: estimateData.client_id,
        client_email: clientData.email,
        po_number: estimateData.po_number,
        subtotal: estimateData.subtotal,
        discount: estimateData.discount,
        tax: estimateData.tax,
        total: estimateData.total,
        markup: estimateData.markup,
        date: estimateData.date,
        days_to_pay: estimateData.days_to_pay,
        notes: estimateData.notes,
        items: JSON.stringify(
          estimateData.items.filter((item) => item.name !== "item name")
        ),
        forms: JSON.stringify([]),
        // forms: JSON.stringify(estimateData.forms),
      };
      let fd = new FormData();
      for (const key of Object.keys(param)) {
        console.log(`"${key}"`, param[key]);
        fd.append(`${key}`, param[key]);
      }
      estimateData?.documents
        ?.filter((item) => item.document_type === "attachments")
        .forEach((item, index) => {
          fd.append(`attachments[${index}]`, item.file_url);
        });

      estimateData?.documents
        ?.filter((item) => item.document_type === "photos")
        .forEach((item, index) => {
          fd.append(`photos[${index}]`, item.file_url);
        });
      setIsLoading(true);
      axios
        .post(host + `save-invoice`, fd, {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: "Bearer " + token,
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then(({ data }) => {
          if (data.status) {
            localStorage.removeItem("invoiceData");
            alertify.success("Invoice has been generated successfully");
            history.push(`/invoices/view/${data.invoice_id}`);
          } else {
            displayAlertifyError({ error: "Error in generating invoice" });
          }
        })
        .finally(() => setIsLoading(false));
    }
  };

  function updateAddress(clientData) {
    const clientAddress = clientData.address;
    const clientCity = clientData.city;
    const clientState = clientData.state;
    const clientPostalCode = clientData.postel_code;
    
    // Concatenating only if city, state, and postal code are not already in the address
    let address = clientAddress;
    if (!address.includes(clientCity)) {
      if (address.includes(clientState) && address.includes(clientPostalCode)) {
        // If state and postal code already exist, then add city before state
        address = address.replace(clientState, clientCity + ' ' + clientState);
      } else {
        address += ' ' + clientCity;
      }
    }
    if (!address.includes(clientState)) {
      address += ' ' + clientState;
    }
    if (!address.includes(clientPostalCode)) {
      address += ' ' + clientPostalCode;
    }
    
    // Setting the final address
    setAddressmain(address);
  }
  
  
  const formatCurrency = (number) => {
    return parseFloat(number).toLocaleString(undefined, {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    });
  };

  const getestimateData = async (estimate_id) => {
    await axios
      .get(host + `show-estimate/${estimate_id}`, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        setestimateData(res.data.data);
        getClientData(res.data.data.client_id);
      })
      .catch((err) => console.log(err));
  };
  const getClientData = async (client_id) => {
    await axios
      .get(host + "client-detail/" + client_id, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        setClientData(res.data.client);
        updateAddress(res.data.client);
        setTimeout(() => {
          setLoading(false);
        }, 500);
      })
      .catch((err) => {
        console.log(err);
        displayAlertifyError({ error: err });
      });
  };

  function sendEmail(estimate_id) {
    const param = { estimate_id: estimate_id, type: "estimate" };
    setIsMailLoading(true);
    axios
      .post(APIModel.HOST + "send-email", param, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        alertify.success(res.data.message);
      })
      .catch((err) => displayAlertifyError({ error: err }))
      .finally(() => setIsMailLoading(false));
  }
  function deleteEstimate(id) {
    const param = { id: id };
    setIsDeleteLoading(true);
    axios
      .post(APIModel.HOST + "delete-estimate", param, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        alertify.success(res.data.message);
        setTimeout(() => {
          history.push("/estimates");
        });
      })
      .catch((err) => displayAlertifyError({ error: err.message }))
      .finally(() => setIsDeleteLoading(false));
  }

  if (token) {
    if (user_status === "user") {
      return <Redirect to="/payment"></Redirect>;
    } else {
      return (
        <>
          <div className="wrapper">
            <SideNav />
            <div className="main-panel">
              <div className="content">
                <div className="container-fluid">
                  <DivNewInvoiceHeader>
                    <h3 className="font-weight-bold my-0">
                      Estimate #{estimateData.po_number}
                    </h3>
                    <div>
                      {isLoading ? (
                        <button
                          type="disabled"
                          class="btn btn-primary ml-2"
                          style={{ opacity: ".5" }}
                        >
                          Generating...
                        </button>
                      ) : (
                        <button
                          type="button"
                          class="btn btn-primary ml-2"
                          onClick={handleGenerateInvoice}
                        >
                          Generate Invoice
                        </button>
                      )}

                      {clientData.user_id && (
                        <a
                          href={
                            APIModel.URL +
                            "form6/" +
                            clientData.user_id
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          class="btn btn-primary ml-2"
                        >
                          Authorize Additional Work
                        </a>
                      )}

                      {isMailLoading ? (
                        <button
                          type="disabled"
                          class="btn btn-primary ml-2"
                          style={{ opacity: ".5" }}
                        >
                          Mailing...
                        </button>
                      ) : (
                        <button
                          type="button"
                          class="btn btn-primary ml-2"
                          onClick={() => {
                            sendEmail(estimateParamId);
                          }}
                        >
                          Mail
                        </button>
                      )}

                      {isDeleteLoading ? (
                        <button
                          type="disabled"
                          class="btn btn-primary"
                          style={{ opacity: ".5" }}
                        >
                          Deleting...
                        </button>
                      ) : (
                        <button
                          type="button"
                          class="btn btn-primary"
                          onClick={() => {
                            deleteEstimate(estimateParamId);
                          }}
                        >
                          Delete
                        </button>
                      )}
                    </div>
                  </DivNewInvoiceHeader>
                  {!loading ? (
                    <DivEstimate>
                      <div className="container">
                        <div className="estimate-head">
                          <div className="head-left">
                            <p>
                              {" "}
                              <span className="heading">Name : </span>
                              {clientData.name}
                            </p>
                            <p>
                              {" "}
                              <span className="heading">Address : </span>
                              {addressmain}
                            </p>
                            <p>
                              {" "}
                              <span className="heading">Email : </span>
                              {clientData.email}
                            </p>
                            <p>
                              {" "}
                              <span className="heading">Date : </span>
                              {estimateData.date}
                            </p>
                          </div>
                          {/* <div className="head-right">
                                                <div>Pixelpk</div>
                                                <div>Joher town g1</div>
                                                <div>+923078801559</div>
                                            </div> */}
                        </div>
                      </div>
                      <ViewEstimateTable tableItems={estimateData.items} />

                      <div className="container pt-2">
                        <div class="row">
                          <div class="col-12">

                            <List
                              component="nav"
                              aria-label="secondary mailbox folders"
                            >
                              <ListItem>
                                <ListItemText>Subtotal</ListItemText>
                                <ListItemSecondaryAction>
                                  <ListItemText>
                                    $
                                    {estimateData.subtotal === 0
                                      ? "0.00"
                                      : formatCurrency(estimateData.subtotal)}
                                  </ListItemText>
                                </ListItemSecondaryAction>
                              </ListItem>
                              <Divider />
                              <ListItem>
                                <ListItemText>Total Tax</ListItemText>
                                <ListItemSecondaryAction>
                                  <ListItemText>
                                    $
                                    {estimateData.tax === 0
                                      ? "0.00"
                                      : formatCurrency(estimateData.tax)}
                                  </ListItemText>
                                </ListItemSecondaryAction>
                              </ListItem>
                              <Divider />
                              <ListItem>
                                <ListItemText>Total Discount</ListItemText>
                                <ListItemSecondaryAction>
                                  <ListItemText>
                                    $
                                    {estimateData.discount === 0
                                      ? "0.00"
                                      : formatCurrency(estimateData.discount)}
                                  </ListItemText>
                                </ListItemSecondaryAction>
                              </ListItem>
                              <Divider />
                              <ListItem>
                                <ListItemText>Grand Total</ListItemText>
                                <ListItemSecondaryAction>
                                  <ListItemText>
                                    $
                                    {estimateData.total === 0
                                      ? "0.00"
                                      : formatCurrency(estimateData.total)}
                                  </ListItemText>
                                </ListItemSecondaryAction>
                              </ListItem>
                            </List>

                          </div>
                        </div>
                      </div>

                      <div className="container pt-3">
                        <div className="row">
                          <div className="col-12 mb-4">
                            <Typography variant="h5">Notes</Typography>
                            <br />
                            <Typography
                              variant="body1"
                              sx={{ fontSize: "1.4rem" }}
                            >
                              {estimateData?.notes
                                ? estimateData.notes
                                : "No notes"}
                            </Typography>
                          </div>

                          <div className="col-12">
                            <Typography variant="h5">Photos</Typography>
                            <br />
                            <Grid container spacing={2}>
                              {estimateData.documents.filter(
                                (item) => item.document_type === "photos"
                              ).length > 0
                                ? estimateData.documents
                                  .filter(
                                    (item) => item.document_type === "photos"
                                  )
                                  .map((item, index) => {
                                    return (
                                      <Grid item xs={3} key={index}>
                                        <span className="image" key={item.id}>
                                          <img
                                            src={
                                              item.url
                                                ? `${item.url}`
                                                : `${item.file_url}`
                                            }
                                            alt={item.document_type}
                                          />
                                          <br />
                                          <span>{item.description}</span>
                                        </span>
                                      </Grid>
                                    );
                                  })
                                : "No photos were selected"}
                            </Grid>

                          </div>
                        </div>
                      </div>

                      <div className="container pt-3">
                        <div className="row">
                          <div className="col-12">
                            <Typography variant="h5">Attachments</Typography>
                            <br />
                            {estimateData.documents.filter(
                              (item) => item.document_type === "attachments"
                            ).length > 0
                              ? estimateData.documents
                                .filter(
                                  (item) =>
                                    item.document_type === "attachments"
                                )
                                .map((item) => {
                                  return (
                                    <div>
                                      <a
                                        target="_blank"
                                        href={`${item.file_url}`}
                                      >
                                        <button
                                          type="button"
                                          className="btn btn-primary"
                                        >
                                          Download
                                        </button>
                                      </a>
                                    </div>
                                  );
                                })
                              : "No documents were selected"}
                          </div>
                        </div>
                      </div>
                    </DivEstimate>
                  ) : (
                    <DivLoader>
                      <Loader
                        type="Oval"
                        color="#FC3538"
                        height={50}
                        width={50}
                      />
                    </DivLoader>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
  } else {
    return <Redirect to="/"></Redirect>;
  }
};

export default ViewEstimate;

const DivNewInvoiceHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 10px;
  background-color: white;
  border-radius: 6px;
  padding: 14px;
  button {
    margin: 0px 5px;
  }
`;
const DivEstimate = styled.div`
  padding: 10px;
  background-color: white;
  border-radius: 6px;
  img {
    margin: 5px;
    width: 150px;
    height: 150px;
    object-fit: cover;
    cursor: pointer;
    transition: 0.25s all ease-in-out;
  }
  .estimate-head {
    margin: 15px 0px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .heading {
      font-weight: bold;
      color: black;
    }
    .head-right {
      text-align: right;
    }
  }
`;

const DivLoader = styled.div`
  text-align: center;
  margin: 30px 0px;
`;
